import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ShipmentsComponent } from './components/shipments.component';

const shipmentsRoutes: Routes = [
  {
    path: '',
    component: ShipmentsComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(shipmentsRoutes)],
  exports: [RouterModule],
  providers: [],
})
export class ShipmentsRoutingModule {}
